// Pure helpers for the recording play bar (Leads centre v2).

/** 75 -> "1:15", 3725 -> "1:02:05", a bad value -> "0:00". */
export function clockLabel(totalSeconds: number): string {
  const s = Number.isFinite(totalSeconds) ? Math.max(0, Math.floor(totalSeconds)) : 0;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const two = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${two(m)}:${two(sec)}` : `${m}:${two(sec)}`;
}

/** The filled share of the bar, 0 to 100, whole numbers. An unknown total reads 0, never NaN. */
export function barPercent(elapsed: number, total: number): number {
  if (!Number.isFinite(elapsed) || !Number.isFinite(total) || total <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((elapsed / total) * 100)));
}

/**
 * The total the bar shows. BEFORE play the audio has not been loaded (and must not be: the signed URL is fetched only on the press of Play), so
 * the total is the call's KNOWN duration; once the audio reports its own length that wins, less the hold silence before the lead joined.
 * Unknown everywhere reads 0 (the clock then says 0:00).
 */
export function shownTotal(audioTotalSeconds: number, startSeconds: number, knownDurationSeconds: number | null | undefined): number {
  if (Number.isFinite(audioTotalSeconds) && audioTotalSeconds > 0) return Math.max(0, audioTotalSeconds - Math.max(0, startSeconds));
  return typeof knownDurationSeconds === 'number' && Number.isFinite(knownDurationSeconds) && knownDurationSeconds > 0 ? Math.floor(knownDurationSeconds) : 0;
}

/**
 * Where a click on the bar seeks to, in the AUDIO's own time: `fraction` (0 to 1, from the click's position across the bar) of the shown
 * total, after the hold silence. Clamped inside the audio, so a click can never seek past the end or before the lead joined.
 */
export function seekTarget(fraction: number, startSeconds: number, audioTotalSeconds: number): number {
  const f = Number.isFinite(fraction) ? Math.min(1, Math.max(0, fraction)) : 0;
  const start = Math.max(0, startSeconds);
  const span = Math.max(0, audioTotalSeconds - start);
  return Math.min(audioTotalSeconds > 0 ? audioTotalSeconds : 0, start + f * span);
}
